import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IChatItem, IConversationItem } from 'constants/chat.interface';

const chatItemInitialState: IChatItem = {
  isLoading: false,
  isAutoScrollDisabled: false,
  chat_history_id: null,
  history: [],
};

const activeChatItem = createSlice({
  name: 'chatHistory',
  initialState: chatItemInitialState,
  reducers: {
    setActiveChatData: (state, action: PayloadAction<IChatItem>) => ({ ...state, ...action.payload }),
    addNewQuery: (state, action: PayloadAction<IConversationItem>) => {
      state.history.push(action.payload);
      state.isLoading = true;
      state.isAutoScrollDisabled = false;
      return state;
    },
    resetActiveChatData: () => chatItemInitialState,
  },
});

export const { addNewQuery, setActiveChatData, resetActiveChatData } = activeChatItem.actions;
export default activeChatItem.reducer;
